var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 3.33337H8.66667M6.13333 14.6667H9.86667C10.6134 14.6667 10.9868 14.6667 11.272 14.5214C11.5229 14.3936 11.7268 14.1896 11.8547 13.9387C12 13.6535 12 13.2801 12 12.5334V3.46671C12 2.71997 12 2.3466 11.8547 2.06139C11.7268 1.8105 11.5229 1.60653 11.272 1.4787C10.9868 1.33337 10.6134 1.33337 9.86667 1.33337H6.13333C5.3866 1.33337 5.01323 1.33337 4.72801 1.4787C4.47713 1.60653 4.27316 1.8105 4.14532 2.06139C4 2.3466 4 2.71997 4 3.46671V12.5334C4 13.2801 4 13.6535 4.14532 13.9387C4.27316 14.1896 4.47713 14.3936 4.72801 14.5214C5.01323 14.6667 5.3866 14.6667 6.13333 14.6667Z",
    stroke: "#9898B3",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.b1f61786961db4063ad22c178d09ed99.svg";
export { ForwardRef as ReactComponent };